module.exports = __webpack_public_path__ + "assets/number.7e0faaa5.svg";